import { useState, useEffect } from "react";
import { HashRouter, Routes, Route, useParams } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { Post as PostPage } from "./pages/Post";

interface Post {
  slug: string;
  title: string;
  date: string;
  excerpt: string;
  content: string;
}

function PostRoute({ posts }: { posts: Post[] }) {
  const { slug } = useParams();
  const postIndex = posts.findIndex((p) => p.slug === slug);
  const post = posts[postIndex];

  if (!post) {
    return <div>Post not found</div>;
  }

  // posts sorted newest first: index 0 = newest, index length-1 = oldest
  const isOldest = postIndex === posts.length - 1;
  const isNewest = postIndex === 0;
  const prevPost = isOldest ? null : posts[postIndex + 1]; // newer post (left side)
  const nextPost = isNewest ? null : posts[postIndex - 1];  // older post (right side)

  return (
    <PostPage 
      title={post.title} 
      date={post.date} 
      content={post.content} 
      prevPost={prevPost} 
      nextPost={nextPost} 
      isOldest={isOldest}
    />
  );
}

export function App() {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/posts.json")
      .then((res) => res.json())
      .then((data) => {
        setPosts(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <HashRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home posts={posts} />} />
          <Route path="posts/:slug" element={<PostRoute posts={posts} />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}
